import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import Home from "./Home";

class Project1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  toggleExpand = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };
  render() {
    const { expanded } = this.state;
    return (
      <div className="Project1">
        <>
          <div className="ButtonMenu">
            <Link to="../Home#about">
              <button className="Menu">&#60;About&#62;</button>
            </Link>
            <Link to="../Home#work">
              <button className="Menu">&#60;Work&#62;</button>
            </Link>
            <button>
              <Link to="../Home#contact" className="Menu">
                &#60;Contact&#62;
              </Link>
            </button>
          </div>

          <div className="workbody">
            <div id="workdescription">
              {" "}
              <h4>
                PRAY.IMG - <br />
                <span className="h2description">
                  {" "}
                  A handmade electronic that blends symbolism, art, and
                  technology.{" "}
                </span>
              </h4>
              <section id="projecttext2">
                <div>
                  <p>
                    Born out of curiosity for faith in a digital age, the device
                    is meant to be held, questioned, and treasured. Includes two
                    interactive game modes: get a sign, and pilgrimage mode
                    (location based) with over 100 unique images and thousands
                    of locations.{" "}
                    <a
                      className="links2"
                      href="https://prayimg.myshopify.com/products/pray-img"
                      target="_blank"
                    >
                      <br />
                      [PRE-ORDER LINK]
                    </a>
                  </p>
                </div>
              </section>
              <section id="projecttext">
                <div className="projecttext"></div>
              </section>
            </div>
            <figure className="image1">
              <img
                src="/img/p1object1.png"
                className="img_gallery2"
                alt="Prayimg"
              />
              <p className="appear">Prayimg image</p>
            </figure>
          </div>
        </>
        <h5>
          <br />
          [PROCESS & MORE]
        </h5>

        <div className="galleryplacement">
          <a
            href="https://www.instagram.com/p/DPULst1Cd1-/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="img_gallery4"
              src="/ig_post1.jpg"
              alt="Instagram post"
            />
          </a>

          <a
            href="https://www.instagram.com/reel/DQH4szEEkkf/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="img_gallery4"
              src="/ig_post2.jpg"
              alt="Instagram post"
            />
          </a>

          <a
            href="https://www.instagram.com/reel/DM9zUtSui6G/"
            target="_blank"
            rel="noreferrer"
          >
            <img className="img_gallery4" src="/ig_post3.jpg" />
          </a>
        </div>
      </div>
    );
  }
}

export default Project1;
